import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_checkmark",
  "use": "svg_checkmark-usage",
  "viewBox": "0 0 19 19",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 19\" id=\"svg_checkmark\"><path d=\"M9.1.1c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm0 16.9c-4.3 0-7.9-3.5-7.9-7.9s3.5-7.9 7.9-7.9S17 4.8 17 9.1 13.5 17 9.1 17z\" /><path d=\"M7.6 11.2 5 8.6l-.8.8 3.4 3.4L14 6.4l-.8-.8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol